import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-blush" data-id="element-106" data-mp="1o5q1qgnuw7zz">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-107" data-mp="222wh019dfokg">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-plum bg-white text-plum" data-id="element-108" data-mp="1x421b86pag4k">
          <span className="font-display text-4xl leading-none" data-id="element-109" data-mp="19co8z28jukjl">7</span>
          <span className="text-[10px] font-semibold uppercase tracking-widest" data-id="element-110" data-mp="14gz3ki9um9fd">
            Days
          </span>
        </div>
        <p className="mt-6 text-[12px] font-bold uppercase tracking-[1.6px] text-coral-deep" data-id="element-111" data-mp="1j6n61mtrne4o">
          Zero risk
        </p>
        <h2 id="guarantee-heading" className="mt-3 font-display text-plum text-3xl sm:text-5xl" data-id="element-112" data-mp="qnzqso1gatbi">
          Open everything.{' '}
          <span className="text-smoke" data-id="element-113" data-mp="lowk6z5tof1f">Run a week of groups from it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-ink-soft" data-id="element-114" data-mp="oyqalznmtfex">
          Read the volumes, place your students on the grid and run a stacked
          session straight from the page. If Session Ready SLP doesn&apos;t
          change how you plan your mixed groups, email us within 7 days and you
          get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-115" data-mp="60nl7jr69ggl">
          {chips.map(chip => <li key={chip} className="rounded-full border border-blush-dark bg-white px-4 py-2 text-[13px] text-ink" data-id="element-116" data-mp="azgwr6mwexe4">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}